import { render, staticRenderFns } from "./templateselection.vue?vue&type=template&id=59e08932&scoped=true&"
import script from "./templateselection.vue?vue&type=script&lang=js&"
export * from "./templateselection.vue?vue&type=script&lang=js&"
import style0 from "./templateselection.vue?vue&type=style&index=0&id=59e08932&scoped=true&lang=css&"
import style1 from "./templateselection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e08932",
  null
  
)

export default component.exports